export const environment = {
  assetBaseUrl: '/assets/ace',
  baseUrl: 'https://avatar-api.abg-mynd.com',
  topicsApiBaseUrl: 'https://avatar-api.abg-mynd.com/avatar-topics',
  knowledgeSourceLoadingUrl: 'http://172.105.79.110:9201/ingest/web/batch',
  playlistsUrl: 'https://avatar-api.abg-mynd.com/avatar-core/',
  new_case_api_url: '/new-case-mgmt/casemanagement/',
  case_api_url: '/case-management',
  ssoBaseUrl: 'https://abg-reporting-api.abg-ace.ai/sso',
  chatBaseUrl: 'https://avatar-api.abg-mynd.com/chat/api',
  outOfScopeUrl: 'https://avatar-api.abg-mynd.com/avatar-core/api/out-of-scope',
  reportUrl: 'https://avatar-api.abg-mynd.com/avatar-audit/api/report',
  appVar: "avadmin",
  version: "0.0.1-rc.175",
  workflow_api_url: '/workflow/',
  alert_api_url: '/alert',
  common_url: '/case-rule-common/api',
  rule_api_url: '/rule-management/api',
  report_api_url: '/report/api',
  endpoints: {
    avatarCore: {
      getAvatars: '/avatar-core/avatar',
      addAvatar: '/avatar-core/avatar',
      editAvatar: '/avatar-core/avatar/',
      deleteAvatar: '/avatar-core/avatar/',
      getAvatarVoices: '/avatar-core/avatar-voice',
      getAvatarConfigurationByAvatarId:
        '/avatar-core/avatar-configuration/avatar/{id}',
      getAvatarThemes: '/avatar-core/avatar-themes',
      getAvatarThemeById: '/avatar-core/avatar-themes/{id}',
      updateKnowledgeBase:
        '/avatar-core/avatar-configuration/update-knowledge-base',
      setDefaultAvatar: '/avatar-core/avatar/set-default/{avatarId}',
      updateAvatarSettings: '/avatar-core/avatar-settings/update-settings',
      getAvatarSettings: '/avatar-core/avatar-settings/settings',
      updateAvatarSettingsShuffleMode:
        'avatar-core/avatar-settings/shuffle-mode?shuffleMode={bool}',
      updateAvatarIdleTime:
        '/avatar-core/avatar-settings/idle-time?idleTime={idleTime}',
      playlistSettings: '/avatar-core/avatar-settings/playlist-settings',
      playlistSettingsMessage: '/avatar-settings/playlist-settings',
      updateBackgroundColor:
        '/avatar-core/avatar-settings/update-avatar-bg/{bgValue}',
      updateAvatarBackgroundColor: '/avatar-core/avatar/update-avatar-bg',
      addAvatarThemes: '/avatar-core/avatar-themes/add-avatar-theme',
      deleteAvatarTheme: '/avatar-core/avatar-themes/delete-avatar-theme',
      getLanguages: '/avatar-core/languages',
      getAllLanguages: '/avatar-core/languages/all',
      getLanguageById: '/avatar-core/languages/',
      addLanguage: '/avatar-core/languages',
      editLanguage: '/avatar-core/languages/',
      deleteLanguage: '/avatar-core/languages/',
      getMetrics: '/avatar-audit/avatar-metrics/get-metrics',
      getAudit: '/avatar-audit/user-actions',
      channels: '/avatar-core/api/channel',
      channelManagement: '/avatar-core/api/channel-management',
      addKnowledgeSource: 'avatar-core/api/knowledgeSource/add',
      getKnowledgeSources: 'avatar-core/api/knowledgeSource/',
      knowledgeIntake: '/avatar-core/api/knowledge-intake',
      updateAvatarCameraSettings: '/avatar-core/avatar/{id}/camera-settings',
      messageFeedback: 'avatar-audit/avatar-interactions/rated',
      getUserExperience: 'avatar-audit/api/user-experience'
    },
    contextProfiles: {
      getAll: 'avatar-core/api/profiles',
      getById: 'avatar-core/api/profiles/{id}',
      create: 'avatar-core/api/profiles',
      update: 'avatar-core/api/profiles/{id}',
      activate: 'avatar-core/api/profiles/{id}/activate',
      switchStatus: 'avatar-core/api/profiles/switch-status',
      documents: 'avatar-core/api/profiles/{id}/documents',
      documentById: 'avatar-core/api/profiles/{id}/documents/{documentId}',
      documentFile: 'avatar-core/api/knowledge-intake/{documentId}/file',
    },
    faq: {
      base: 'avatar-core/api/faq',
    },
    noiseDictionary: {
      getAll: 'avatar-response/api/noise-dictionary',
      getById: 'avatar-response/api/noise-dictionary/{id}',
      create: 'avatar-response/api/noise-dictionary',
      update: 'avatar-response/api/noise-dictionary/{id}',
      delete: 'avatar-response/api/noise-dictionary/{id}',
      toggleEnabled: 'avatar-response/api/noise-dictionary/{id}/enabled',
      getCategories: 'avatar-response/api/noise-dictionary/category/all',
      getLogs: 'avatar-response/api/noise-dictionary/logs',
      getVariants: 'avatar-response/api/noise-dictionary/{id}/variants',
      addVariant: 'avatar-response/api/noise-dictionary/{id}/variants',
      deleteVariant: 'avatar-response/api/noise-dictionary/variants/{variantId}',
    },
  },
  constants: {
    appSlogant: 'AI That Thinks With You.',
    defaultTheme: 'theme1', // Light mode
    defaultLanguage: 'en', // English
  },
};
